<template>
    <div class="flex flex-col text-left w-full">
        <label class="mb-1 mr-auto md:text-lg text-gray-800" v-if="label">{{ label.capitalize() }}</label>

        <div class="flex items-center w-full">
            <input
                :type="type != null ? type : 'text'"
                :placeholder="placeholder != null ? placeholder.capitalize() : label.capitalize()"
                class="flex-1 py-2 px-4 sm:text-2xl font-semibold border border-gray-500 rounded outline-none appearance-none focus:shadow-outline"
                style="background: #f2f2f2;"
                :class="{'errors' : hasErrors}"
                v-bind:value="value"
                :name="slug"
                step="0.01"
                v-on:input="$emit('input', $event.target.value)"
            >

            <div class="w-10 pl-3" v-if="hasErrors">
                <img src="@/assets/img/error.svg" class="w-auto h-6" />
            </div>
        </div>

        <span v-if="type == 'number'" class="my-2 text-sm italic">{{ $t('validation.attributes.number_help') }}</span>

        <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold" style="color: #f84036">
            <span class="block" v-if="hasErrors">
                <span>{{ errors[0] }}</span>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    props: ['label', 'placeholder', 'value', 'errors', 'slug', 'type'],
    computed: {
        hasErrors: function () {
            return this.errors && this.errors.length > 0;
        }
    }
}

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
</script>

